"use client";

import { apiRemote } from "@/api";
import { useAlert } from "@/contexts/AlertContext";
import { useUser } from "@/contexts/UserContext";
import { removeEmojiHtmlTag, sanitizeInputUsername } from "@/utils/sanitizeInput";
import { validateEmail, validateUsername } from "@/utils/validation";
import {
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";

export default function ParentConnection() {
  var { user } = useUser();
  const alert = useAlert();
  const navigate = useNavigate();
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [formData, setFormData] = useState({
    username: "",
    email: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    let sanitizedValue = value;

    if(name === 'username'){
      sanitizedValue = sanitizeInputUsername(value);
      const userNameError = validateUsername(sanitizedValue);
      setErrors((prev) => ({
          ...prev,
          username: userNameError,
      }));
   }

    if (name === "email") {
      const emailError = validateEmail(value);
      setErrors((prev) => ({
        ...prev,
        email: emailError,
      }));
    }
    console.log(name, value , sanitizedValue, removeEmojiHtmlTag(sanitizedValue), formData);
    setFormData((prev) => ({
      ...prev,
      [name]: removeEmojiHtmlTag(sanitizedValue),
    }));
  };

  const handleConnect = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle connect logic
    if (Object.values(errors).some((error) => error)) {
      alert.error("Please fix the errors before submitting.");
      return;
    }
    // var userid = '166';
    // console.log(formData);
    apiRemote.connectParent({
        type: "connectparent",
        username_parent: formData.username,
        child_id: user?.ID || '',
        // child_id: userid || '',
    }).then((res)=>{
      if(res.code == 200){
        alert.success(res.message);
        setFormData((prev) => ({
          ...prev,
          username: "",
        }));
        navigate(`./success-connect`);
      }else{
          alert.error(res.message);
      }
        
    }).catch((err)=>{
        alert.error(err.message);
        throw err;
    });
  };

  const handleInvite = (e: React.FormEvent) => {
    e.preventDefault();
    // var userid = '166';
    // Handle invite logic
    apiRemote.connectParent({
      type: "inviteparent",
      email_parent: formData.email,
      child_id: user?.ID || '',
      // child_id: userid || '',
    }).then((res)=>{
        if(res.code == 200){
            alert.success(res.message);
            setFormData((prev) => ({
              ...prev,
              email: "",
            }));
            navigate(`./success-invite`);
        }else{
            alert.error(res.message);
        }
        
    }).catch((err)=>{
        alert.error(err.message);
        throw err;
    });
  };

  return (
    <Box
      sx={{
        p: 3,
        bgcolor: "white",
        borderRadius: 2,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        flex: 1,
      }}
    >
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography
            variant="h6"
            sx={{
              color: "rgb(0, 102, 204)",
              mb: 3,
              fontWeight: "bold",
              borderBottom: "1px solid #e0e0e0",
              pb: 1,
            }}
          >
            CONNECT TO PARENT ACCOUNT
          </Typography>

          <Typography align="center" color="error" sx={{ mb: 3 }}>
            If your parent already registered an account on Pythaverse, please
            input your parent's username to connect :
          </Typography>

          <Box sx={{ maxWidth: 600, mx: "auto" }}>
            <form onSubmit={handleConnect}>
              <Box
                sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}
              >
                <Typography
                  component="label"
                  htmlFor="username"
                  sx={{ width: 100 }}
                >
                  Username:
                </Typography>
                <TextField
                  id="username"
                  name="username"
                  fullWidth
                  placeholder="Enter your parent's username"
                  value={formData.username}
                  inputProps={{ maxLength: 20 }}
                  onChange={handleChange}
                  required
                  error={!!errors.username}
                  helperText={errors.username}
                />
              </Box>

              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    bgcolor: "#ff4d00",
                    "&:hover": {
                      bgcolor: "#cc3d00",
                    },
                  }}
                >
                  Connect this account
                </Button>
              </Box>
            </form>
          </Box>
        </Paper>

        <Paper sx={{ p: 4 }}>
          <Typography
            variant="h6"
            sx={{
              color: "rgb(0, 102, 204)",
              mb: 3,
              fontWeight: "bold",
              borderBottom: "1px solid #e0e0e0",
              pb: 1,
            }}
          >
            INVITE YOUR PARENT TO REGISTER ACCOUNT ON PYTHAVERSE
          </Typography>

          <Typography align="center" color="error" sx={{ mb: 3 }}>
            Send an invitation to your parent's email address to register an
            account to Pythaverse, and that account will be connected to your
            account:
          </Typography>

          <Box sx={{ maxWidth: 600, mx: "auto" }}>
            <form onSubmit={handleInvite}>
              <Box
                sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}
              >
                <Typography
                  component="label"
                  htmlFor="email"
                  sx={{ width: 100 }}
                >
                  Email:
                </Typography>
                <TextField
                  id="email"
                  name="email"
                  fullWidth
                  placeholder="Enter your parent's email"
                  type="email"
                  required
                  value={formData.email}
                  error={!!errors.email}
                  helperText={errors.email}
                  onChange={handleChange}
                />
              </Box>

              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    bgcolor: "#ff4d00",
                    "&:hover": {
                      bgcolor: "#cc3d00",
                    },
                  }}
                >
                  Send Invitation
                </Button>
              </Box>
            </form>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
